import { render } from "./UserAvatar.vue?vue&type=template&id=6029d10c&scoped=true&ts=true"
import script from "./UserAvatar.vue?vue&type=script&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&lang=ts"

import "./UserAvatar.vue?vue&type=style&index=0&id=6029d10c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6029d10c"]])

export default __exports__